import mediumZoom from 'medium-zoom/dist/medium-zoom';

document.addEventListener('DOMContentLoaded', () => {
    mediumZoom('.event-plan img');
});

